var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookingDetilsStepIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "#2E77D0",
    stroke: "#2E77D0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71181 9C8.11807 9.02474 7.99025 9.46386 8.00056 9.68033V19.9471C8.00056 20.8377 8.47473 21.0191 8.71181 20.9985H20.4938C21.1618 20.9737 21.2463 20.1635 21.2051 19.7615V12.5253C21.2298 11.8326 20.6175 11.6595 20.3083 11.6595H16.8139C16.1336 11.5667 15.948 12.2367 16.0099 12.5253V14.3808H14.6183V9.86587C14.6183 9.17317 13.9998 9 13.6906 9H8.71181ZM9.32983 10.5164H10.6905V11.8771H9.32983V10.5164ZM13.381 10.5164H12.0203V11.8771H13.381V10.5164ZM9.32983 13.1133H10.6905V14.4739H9.32983V13.1133ZM13.381 13.1133H12.0203V14.4739H13.381V13.1133ZM18.0193 13.1133H19.3799V14.4739H18.0193V13.1133ZM19.3799 15.709H18.0193V17.0696H19.3799V15.709ZM9.32983 15.709H10.6905V17.0696H9.32983V15.709ZM13.381 15.709H12.0203V17.0696H13.381V15.709Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingDetilsStepIcon);
export default __webpack_public_path__ + "static/media/booking-detils-step-icon.4b69694c2bb257e54c20737db0cbc4b3.svg";
export { ForwardRef as ReactComponent };